<section class="m-4" *ngIf="form">
  <h1 translate>Assignments</h1>
  <div class="h-100 p-2">
    <!-- Dynamic form -->
    <form [formGroup]="form">
      <div class="row bg-white p-2 rounded-3">
        <div
          *ngFor="let question of questions"
          class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
        >
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
    </form>

    <!-- Assignment Cards -->
    <div class="row mt-4">
      <div
        *ngFor="let assignment of assignments"
        class="mb-3 col-12 col-sm-6 col-md-4 subjectCards"
      >
        <mat-card (click)="onSubjectView(assignment)" class="h-100">
          <mat-card-header>
            <mat-card-subtitle class="cardSubTitle">{{
              assignment.subject
            }}</mat-card-subtitle>
            <mat-card-title class="cardTitle">{{
              assignment.title
            }}</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <small>
              <div class="d-flex justify-content-between align-items-center">
                <div class="deadline-info">
                  <i class="fa-solid fa-calendar-days me-1"></i>
                  {{ assignment.type }} {{ assignment.date }}
                </div>

                <span
                  class="badge"
                  [ngClass]="{
                    'status-pending': assignment.status === 'Pending',
                    'status-submitted': assignment.status === 'Submitted',
                    'status-graded': assignment.status === 'Graded'
                  }"
                >
                  {{ assignment.status }}
                </span>
              </div>
            </small>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</section>
